// ProfileVideos.tsx — the profile's Videos tab (1.27.60): the member's channel as a grid of
// the same cards the Videos page uses. On your own profile an unlisted video is marked, so
// you can tell which ones only people with the link can find.
import styled from 'styled-components';
import type { Post } from '@/core/models';
import { media } from '@/theme/media';
import { Icon } from '@/icons';
import { VideoCard } from '@/features/videos/VideoCard';
import { toCards } from '@/features/videos/real/realItems';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  padding: 12px 0;
  ${media.mobile`grid-template-columns: 1fr;`}
`;

const Cell = styled.div`
  display: grid;
  gap: 6px;
`;

const Mark = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  justify-self: start;
  font: 600 ${({ theme }) => theme.fontSize.xs} ${({ theme }) => theme.font.body};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function ProfileVideos({ posts, isOwn }: { posts: Post[]; isOwn: boolean }) {
  const { items, creators } = toCards(posts);
  const unlisted = new Set(posts.filter((p) => p.audience?.type === 'unlisted').map((p) => p.id));
  return (
    <Grid data-testid="profile-videos">
      {items.map((v) => (
        <Cell key={v.id}>
          <VideoCard video={v} creator={creators[v.authorId]} />
          {isOwn && unlisted.has(v.id) && (
            <Mark>
              <Icon name="link" size={13} />
              Unlisted
            </Mark>
          )}
        </Cell>
      ))}
    </Grid>
  );
}
